import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import {formatMoney} from 'core/utils';
import EmptyMessage from 'components/empty-message';
import PercentageBar from 'components/percentage-bar';
import styles from './styles.css';

@autobind
export default class CreditChart extends Component {
    static propTypes = {
        creditSummary: PropTypes.object.isRequired,
        transactionsByCategory: PropTypes.array.isRequired,
        adminVersion: PropTypes.bool,
    };

    render() {
        const {creditSummary, adminVersion} = this.props;
        const transactions = this.props.transactionsByCategory.filter(transaction => {
            return transaction.category.id !== 'available';
        });

        if (this.props.transactionsByCategory.length === 0 && creditSummary.total === 0) return <EmptyMessage />;

        return (
            <div className={classNames(styles.root, {[styles.admin]: adminVersion})}>
                <div className={styles.info}>
                    <p>Crédito total</p>
                    <p>{formatMoney(creditSummary, 'total')}</p>
                </div>
                <div className={styles.info}>
                    <p>
                        Crédito disponible
                        <span>{`(${creditSummary.availablePercentage}%)`}</span>
                    </p>
                    <p>{formatMoney(creditSummary, 'available')}</p>
                </div>
                <div className={styles.info}>
                    <p>
                        Crédito consumido
                        <span>{`(${creditSummary.consumedPercentage}%)`}</span>
                    </p>
                    <p>{formatMoney(creditSummary, 'consumed')}</p>
                </div>
                {transactions.length > 0 && (
                    <div className={styles.breakdown}>
                        {transactions.map(transaction => (
                            <div key={transaction.category.id} className={styles.transaction}>
                                <PercentageBar
                                    percentage={transaction.percentage}
                                    width='25%'
                                    fillColor={!adminVersion ? '#E25C5D' : undefined}
                                    emptyColor={!adminVersion ? '#E5B9AE' : '#E4D7A8'}
                                />
                                <div className={styles.name}>
                                    <span>{transaction.category.name}</span>
                                    ({transaction.percentage}%)
                                </div>
                                <div className={styles.amount}>{formatMoney(transaction, 'amount')}</div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./components/credit-chart/index.js